import * as React from 'react';
import { clsx } from 'clsx';
import { IconActionChevronLeft24, IconActionChevronRight24 } from '@cian/ui-kit-design-tokens/icons';
import styles from '../../styles/button.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ScrollButton = _ref => {
  let {
    onClick,
    right
  } = _ref;
  return /*#__PURE__*/_jsx("button", {
    className: clsx(styles['button'], right ? styles['button-right'] : styles['button-left']),
    onClick: onClick,
    tabIndex: -1,
    children: right ? /*#__PURE__*/_jsx(IconActionChevronRight24, {}) : /*#__PURE__*/_jsx(IconActionChevronLeft24, {})
  });
};